<template>
  <section class="container-section">
    <div class="sub-container">
      <loading
        :active="isLoading"
        :is-full-page="true"
      />
      <section class="section-titles">
        <h3 class="title">
          Transporte Interior
        </h3>
      </section>
      <section>
        <div class="list-items uk-flex uk-flex-wrap uk-m">
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="inlandTransportationImport.isGroundTransportationService"
                disabled
                class="uk-checkbox"
                type="checkbox"
              > Servicio de Transporte Terrestre a Destino Final
            </label>
          </div>

          <div class="uk-flex items-label uk-margin-right InputColumn">
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label
                for="timeCharger"
                style="cursor: pointer; margin-bottom: 4px"
              >Tiempo de Espera Para Cargar </label>
            </div>
            <div class="uk-form-controls uk-margin-left isMargin">
              <select
                id="timeCharger"
                v-model="inlandTransportationImport.waitingTimeForCharging"
                class="uk-select uk-width-small filterDistance"
                :disabled="inlandTransportationImport.isGroundTransportationService == null || inlandTransportationImport.isGroundTransportationService == false"
              >
                <option :value="inlandTransportationEnum.upToSixHours">
                  Hasta 6 horas
                </option>
                <option
                  v-if="transportMode == transportModeTypeEnum.maritime"
                  :value="inlandTransportationEnum.moreThanSixHours"
                >
                  Más de 6 horas
                </option>
              </select>
              <label
                v-show="inlandTransportationImport.waitingTimeForCharging === 2 && transportMode == transportModeTypeEnum.maritime"
                class="uk-flex uk-flex-middle"
              >
                Aplicado 50% de Recargo
              </label>
            </div>
          </div>

          <div
            v-if="(transportMode !== transportModeTypeEnum.aerial)"
            style="padding-bottom: 10px"
            class="uk-flex items uk-flex-wrap"
          >
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="inlandTransportationImport.rentChassis"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="inlandTransportationImport.rentalDays = 0"
                > Alquiler Chasis
              </label>
            </div>
            <div
              class="uk-flex"
              style="margin-top: 5px"
            >
              <input
                v-model="inlandTransportationImport.rentalDays"
                :disabled=" rentChassisCondition === true"
                min="0"
                max="9999999"
                class="uk-input uk-form-width-xsmall"
                style="width: 70px; margin-right: 5px"
                type="number"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
              <label class=" uk-flex uk-flex-column uk-flex-center"> Días de Alquiler</label>
            </div>
          </div>

          <div
            v-if="(transportMode !== transportModeTypeEnum.aerial)"
            class="items"
            style="width: 100%; padding-bottom: 10px"
          >
            <label style="cursor: pointer">
              <input
                v-model="inlandTransportationImport.isInspectionCostForUseOwnChassis"
                class="uk-checkbox"
                type="checkbox"
              > Costo de Inspección por Uso de Chasis Propio
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="inlandTransportationImport.needToPayTolls"
                class="uk-checkbox"
                type="checkbox"
              > Pago de Peajes
            </label>
          </div>

          <div class="uk-flex InputColumn">
            <label class="uk-flex uk-flex-middle">Precio de Peaje &nbsp; <span class="opt"> (Pesos)</span></label>
            <input
              v-model="inlandTransportationImport.tollPrice"
              type="number"
              class="uk-input uk-width-small uk-margin-left filterDistance isMargin"
              min="0"
              max="9999999"
              :disabled="!inlandTransportationImport.needToPayTolls"
              @keydown="$helperPlugin.onlyDecimal($event)"
            >
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.import && transportModeTypeEnum.maritime === transportMode"
            class="items"
            style="width: 100%"
          >
            <label style="cursor: pointer; margin: 0 5px 0 10px;">
              Días de Utilización de Importación <span class="opt"> (Opcional) </span>
            </label>
            <input
              v-model="inlandTransportationImport.daysUseInImport"
              class="uk-input uk-form-width-small"
              style="width: 90px; margin-top: 5px"
              type="number"
              min="0"
              max="9999999"
              @keydown="$helperPlugin.onlyNumber($event)"
            >
          </div>
          <div
            class="items"
            style="width: 100%"
          >
            <label style="cursor: pointer">
              <input
                v-model="inlandTransportationImport.hasCirculationPermits"
                class="uk-checkbox"
                type="checkbox"
              > Permisos de Circulación
            </label>
          </div>
          <div
            class="uk-flex InputColumn"
            style="width:100%; margin-top: 10px"
          >
            <div
              v-if="inlandTransportationImport.hasCirculationPermits"
              class="items "
            >
              <label style="cursor: pointer">
                <input
                  v-model="inlandTransportationImport.hasHolidays"
                  class="uk-checkbox"
                  type="checkbox"
                >  Días Festivos
              </label>
            </div>

            <div
              v-if="inlandTransportationImport.hasCirculationPermits"
              class="items"
            >
              <label style="cursor: pointer">
                <input
                  v-model="inlandTransportationImport.hasOverloadOrDimension"
                  class="uk-checkbox"
                  type="checkbox"
                >  Sobrecarga o Dimensión
              </label>
            </div>
          </div>
        </div>
        <div class="img-tranport">
          <a
            target="_blank"
            href="http://rdvial.gob.do/"
          >
            <img src="../../../../assets/img/tranporte2.png">
            Enlace a Fideicomiso RD Vial</a>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { transportModeTypeEnum, dollyTypeEnum, directionTypeEnum, inlandTransportationEnum } from '../../../../types'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      directionTypeEnum,
      transportModeTypeEnum,
      dollyTypeEnum,
      inlandTransportationEnum,

      inlandTransportationImport: {
        isGroundTransportationService: true,
        waitingTimeForCharging: null,
        hasHolidays: null,
        hasOverloadOrDimension: null,
        hasCirculationPermits: null,
        daysUseInImport: null,
        needToPayTolls: null,
        rentChassis: null,
        isInspectionCostForUseOwnChassis: null,
        rentalDays: null,
        tollPrice: null
      },
      waitingTimeForChargings: [],
      isLoading: false,
      showItem: null

    }
  },
  computed: {
    ...mapGetters([
      'inlandTransportationStore',
      'journeyDirection',
      'transportMode',
      'dollyType'

    ]),
    rentChassisCondition: function () {
      if (this.inlandTransportationImport.rentChassis) {
        return false
      }
      this.changeRentChassisCondition()
      return true
    },
    reeferCondition: function () {
      if (this.dollyType !== dollyTypeEnum.reefer && this.transportMode !== transportModeTypeEnum.aerial && this.journeyDirection !== directionTypeEnum.import) {
        return false
      }
      return true
    }
  },

  watch: {
    inlandTransportationImport: {
      handler: function (newVal) {
        this.$store.commit('setInlandTransportation', newVal)
      },
      deep: true
    },
    'inlandTransportationImport.needToPayTolls': async function (newVal, oldVal) {
      if (this.inlandTransportationImport.needToPayTolls === false) {
        this.inlandTransportationImport.tollPrice = null
      }
      if (this.inlandTransportationImport.needToPayTolls > 9999999) {
        this.inlandTransportationImport.needToPayTolls = oldVal
      }
    },
    'inlandTransportationImport.hasCirculationPermits': function () {
      if (!this.inlandTransportationImport.hasCirculationPermits) {
        this.inlandTransportationImport.hasHolidays = null
        this.inlandTransportationImport.hasOverloadOrDimension = null
      }
    },
    'inlandTransportationImport.rentalDays': function (newVal, oldVal) {
      if (this.inlandTransportationImport.rentalDays > 9999) {
        this.inlandTransportationImport.rentalDays = oldVal
      }
    },
    'inlandTransportationImport.tollPrice': function (newVal, oldVal) {
      if (this.inlandTransportationImport.tollPrice > 9999999) {
        this.inlandTransportationImport.tollPrice = oldVal
      }
    },
    'inlandTransportationImport.daysUseInImport': function (newVal, oldVal) {
      if (this.inlandTransportationImport.daysUseInImport > 9999) {
        this.inlandTransportationImport.daysUseInImport = oldVal
      }
    }
  },
  async mounted () {
    await this.init()
    this.isShowItem()
    this.inlandTransportationImport = { ...this.inlandTransportationStore }
  },

  methods: {
    async init () {
      this.isLoading = true
      try {
        const data = await this.$services.transportChainScenarioService.getChoices()
        this.waitingTimeForChargings = data.waitingTimeForChargings
      } catch (e) {
        console.log(e)
        this.$toast.warning('No se pudo obtener los datos, contáctese con su administrador.', {
          position: 'top',
          duration: 4000
        })
      }
      this.isLoading = false
    },
    changeRentChassisCondition () {
      this.inlandTransportationImport.rentChassis = null
    },
    isShowItem () {
      if (this.transportMode === this.transportModeTypeEnum.aerial && this.journeyDirection === this.directionTypeEnum.import) {
        this.showItem = false
      } else {
        this.showItem = true
      }
    }
  }
}
</script>

<style scoped>
*{
  box-sizing: border-box;
  font-size: 12px;
}
p {

  margin: 10px;
}
.container-section{
  padding: 10px 40px;
}
section{
  width: 98%;
  padding: 10px 10px 20px;
}
.sub-container{
  min-height: 418px;;
}
.title{
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
}

.img-tranport img{
  margin-right: 5px;
}
.uk-checkbox:disabled{
  background: rgb(14, 109, 205);
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
  background-repeat: no-repeat ;
  background-position: 2px 2px 0px 1px;
  border: 1px solid rgb(14, 109, 205) ;

}
.img-tranport{
  margin: 12px 0px
}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}
.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}
.list-items{
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
}
.items{
  margin: 0px 45px 30px 0px;
  min-width: auto;
}
.items-label{
  width:100%;
  margin-bottom: 30px;
}

@media screen and (max-width: 879px){
  .cost-title{
    font-weight: 600;
    width: 100%;
    margin-bottom: 10px;
  }
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .container-section{
    padding: 10px 20px;
}
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
  }
  .opt{
    font-size: 10px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;

  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .items{
    min-width: 100px;
    margin: 0px 10px 20px 0px;
  }

  @media screen and (max-width: 450px){
  .InputColumn {
   display: flex;
   flex-direction: column;
   width: 95%;
  margin: 10px 0 !important;
  }

.filterDistance{
  min-width: 270px;
  max-width: 300%;
  width: 100%;
}
.isMargin {
  margin: 10px 0 !important;

}

}

}
</style>
